import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      const btn = this.element.querySelector("button, [data-action]") || this.element
      const icon = btn.querySelector(".material-symbols-outlined")
      const originalIconText = icon ? icon.textContent : null

      if (icon) icon.textContent = "check"
      btn.classList.add("birth-chart-share__btn--copied")

      setTimeout(() => {
        if (icon && originalIconText) icon.textContent = originalIconText
        btn.classList.remove("birth-chart-share__btn--copied")
      }, 2000)
    })
  }
}
